export enum LayoutEnum {
  absolute = 'absolute',
  fixed = 'fixed',
}
